import { defineStore } from 'pinia'
import { ref } from 'vue'

interface Notification {
  message: string
  type: 'info' | 'success' | 'error'
}

export const useUIStore = defineStore('ui', () => {
  const sidebarOpen = ref(false)
  const currentPage = ref<string>('dashboard')
  const loading = ref(false)
  const notification = ref<Notification | null>(null)
  const selectedFeedbackId = ref<number | null>(null)
  const selectedProductId = ref<number | null>(null)

  const toggleSidebar = () => {
    sidebarOpen.value = !sidebarOpen.value
  }

  const setCurrentPage = (page: string) => {
    currentPage.value = page
  }

  const viewFeedbackDetail = (feedbackId: number) => {
    selectedFeedbackId.value = feedbackId
    currentPage.value = 'detail'
  }

  const setSelectedProduct = (productId: number | null) => {
    selectedProductId.value = productId
  }

  const setLoading = (isLoading: boolean) => {
    loading.value = isLoading
  }

  const showNotification = (message: string, type: 'info' | 'success' | 'error' = 'info') => {
    notification.value = { message, type }
    setTimeout(() => {
      notification.value = null
    }, 3000)
  }

  return {
    sidebarOpen,
    currentPage,
    loading,
    notification,
    selectedFeedbackId,
    selectedProductId,
    toggleSidebar,
    setCurrentPage,
    viewFeedbackDetail,
    setSelectedProduct,
    setLoading,
    showNotification,
  }
})
